
import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import ModelMixin from '@/mixins/ModelMixin';
import ValidateableMixin from '@/mixins/ValidateableMixin';
import { Subscription } from '@/types/subscriptions';
import { convertDateToReadable, unixToReadableDate } from '@/utils/datetime';

@Component({
    components: {},
    mixins: [ModelMixin, ValidateableMixin],
})
export default class PauseSubscriptionConfirmationModal extends Mixins<ValidateableMixin, ModelMixin<boolean>>(
    ValidateableMixin,
    ModelMixin,
) {
    private menu = false;
    protected resumeDate: string = this.minDate;

    @Prop({ required: true })
    subscriptionItem!: Subscription;

    @Prop({ required: true })
    onPause!: (subscription: Subscription, resumeDate: string) => void;

    onClose() {
        this.model = false;
    }

    async save(e: Event) {
        e.preventDefault();
        if (!this.resumeDate) return Vue.toasted.error(`invalid date`);
        await this.onPause(this.subscriptionItem, this.resumeDate);
        this.model = false;
    }

    get minDate() {
        const periodEnd = unixToReadableDate(this.subscriptionItem.sourceData.current_period_end);
        return convertDateToReadable(periodEnd, false, 'YYYY-MM-DD');
    }
}
